import { DocumentData } from 'firebase/firestore';
import { AuthorManager } from '../AuthorManager';
import { IBaseRecording, IRecordingWithAuthor } from '../../types';
import { IRecordingWithModerationInfo, ModerationResult } from './types';

/**
 * Type conversion utilities for recordings
 */

/** Runtime-only fields that must never be written to Firestore Recording documents */
export function stripRuntimeRecordingFields<T extends object>(
  data: T
): Omit<T, 'author'> {
  const { author: _author, ...rest } = data as T & { author?: unknown };
  return rest;
}

export function createBaseRecording(data: DocumentData, key: string): IBaseRecording {
  return {
    ...data,
    key,
    contentRating: data.contentRating,
    requiresModeration: data.requiresModeration
  } as IBaseRecording;
}

export async function createRecordingWithAuthor(
  data: DocumentData,
  key: string
): Promise<IRecordingWithAuthor> {
  const baseRecording = createBaseRecording(data, key);
  const recording: IRecordingWithAuthor = {
    ...baseRecording,
    author: null
  };

  if (recording.ownership?.recordingAuthor) {
    const author = await AuthorManager.getAuthor(recording.ownership.recordingAuthor);
    recording.author = author;
  }

  return recording;
}

export async function createRecordingWithModerationInfo(
  data: DocumentData,
  key: string
): Promise<IRecordingWithModerationInfo> {
  const recordingWithAuthor = await createRecordingWithAuthor(data, key);
  return {
    ...recordingWithAuthor,
    moderationResult: data.moderationResult
  };
}
